<p>deleteanagrafica works!</p>
